<template>
  <div id="app">
    <notifications group="foo" />
    <div class="background-overlay"></div>
    <Header />
    <div class="body-container">
      <div>
          <router-view/>
      </div>
      <div v-if="(!isMobile && $route.path.includes('contact')) || !$route.path.includes('contact')">
        <img :src="require('@/assets/img/logo.svg')"/>
      </div>
      <div v-if="(!isMobile && $route.path.includes('contact')) || !$route.path.includes('contact')">
        <h1>{{$t('home.contact')}}</h1>

        <ul>
          <li>
            <img :src="require('@/assets/img/envelope.svg')" />
            sqgroup@sqgroup.com.br
          </li>
          <li>
            <img :src="require('@/assets/img/phone.svg')" />
            +55 51 3061-2612
          </li>
          <li>
            <img :src="require('@/assets/img/map-marker.svg')" />
            Rua Sport Club São José, 54/502 - Passo d'Areia - CEP 91.030-510 
            Porto Alegre - RS - Brasil
          </li>
        </ul>

        <div>
          <button v-if="!$route.path.includes('contact')" @click="$router.push('/contact')">
            {{$t('home.contact_us')}}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header'
export default {
  name: 'App',
  components:{
    Header
  },
  data(){
    return {
      isMobile: false
    }
  },
  mounted(){

    if(localStorage.getItem('sqLocale') == "null" || localStorage.getItem('sqLocale') == null){
      localStorage.setItem('sqLocale', 'en')
    }
    
    if(document.body.clientWidth <= 804){
      this.isMobile = true
    }
  }
}
</script>

<style lang="scss">
@import '@/assets/scss/main.scss';
</style>



// WEBPACK FOOTER //
// src/App.vue